import { useToast } from '@app/core/notifications';
import { useIntl } from 'react-intl';

export function useErrorHandler() {
  const { formatMessage } = useIntl();
  const { notifyError } = useToast();

  function onApiError(error: unknown) {
    console.error(error);

    notifyError(
      formatMessage({
        id: 'common.form.errorNotification',
        defaultMessage:
          'Ocurrió un error. Por favor verifica todos los campos e intenta nuevamente. Si el error persiste, contacta a soporte',
      }),
    );
  }

  return {
    onApiError,
  };
}
